import React from 'react';
// Libraries
import { List, message } from 'antd';
import { UserDeleteOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import Animate, { FadeIn } from 'animate-css-styled-components';
// Components
import Avatar from '~/components/avatar';
import Button from '~/components/button';
// Utils
import { CapitalizeString, DecodeURI } from '~/utils/Transformations';
import { cpfMask, cnpjMask } from '~/utils/Masks';
import SocialMeAPI from '~/utils/SocialMeAPI';

export default function PeopleList({ people, document, GetPeopleAgain, accessLevel }) {
    const { institutionId, organizationUnitId } = useParams();

    async function RemoveUser(item) {
        const params = {
            operation: ['SIGAM', 'Documents', 'PrivateAccess', 'Delete'],
            urlParams: {
                institutionId,
                organizationUnitId,
                documentId: document.id,
                personId: item.id
            },
        };
        const response = await SocialMeAPI(params);
        if (response.success) {
            message.success('Acesso removido com sucesso!');
            GetPeopleAgain();
        } else {
            message.error('Alguma coisa aconteceu...')
        }
    }

    return (
        <div style={{ marginTop: 10 }}>

            <List
                grid={{ gutter: 18, column: 1 }}
                itemLayout="horizontal"
                dataSource={people}
                locale={{ emptyText: 'Nenhum usuário encontrado' }}
                renderItem={(item) => (
                    <Animate
                        Animation={[FadeIn]}
                        duration={['0.5s']}
                        delay={['0.2s']}
                    >
                        <List.Item actions={ accessLevel && accessLevel.is_in_charge && [
                            <div style={{ marginBottom: 10 }}>
                                <Button onClick={() => RemoveUser(item)} icon={<UserDeleteOutlined />} danger>
                                    Remover acesso
                                </Button>
                            </div>
                        ]}>
                            <List.Item.Meta
                                avatar={<Avatar size={45} src={DecodeURI(item.avatar)} />}
                                title={CapitalizeString(item.social_name || item.name)}
                                description={
                                    item.cpf_number
                                        ? cpfMask(item.cpf_number)
                                        : cnpjMask(item.cnpj_number)
                                }
                            />
                        </List.Item>
                    </Animate>
                )}
            />
        </div>
    )
}